import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";

export interface WorkingLead extends GtagEvent {
    currency:ISO_4217;
    value: number;
    lead_status?:string;
}
export const working_lead = ($_:WorkingLead) => event('working_lead',$_);